module.exports = __webpack_public_path__ + "img/confirm-validation.d36e714c.svg";